import { BaseDb } from "common/BaseDb"
import http, { HttpError, isHttpError, makeAuthHeader } from "common/http"
import { ActivitiesSchemaWithId } from "components/planscan/activities/activities.schema"

class ActivitiesDb extends BaseDb<ActivitiesSchemaWithId> {
    public async createMany(
        recordsToCreate: ActivitiesSchemaWithId[],
        projectId: number,
        sessionId: string | undefined
    ): Promise<Array<(ActivitiesSchemaWithId & RequiredId)[] | HttpError>> {
        if (sessionId !== undefined && typeof sessionId !== "string") {
            return [
                {
                    errorMessage: "session id was malformed",
                    statusCode: 400,
                    record: undefined
                }
            ]
        }

        // The numbering/validation/create fan-out for the whole batch happens server-side in one request
        // (see POST /storage/bulk in activities.server.routes.ts) instead of one request per activity.
        const response = await http.post<Array<(ActivitiesSchemaWithId & RequiredId)[] | HttpError>>(
            `${this.apiUrl}/${this.component}/storage/bulk`,
            recordsToCreate,
            {
                headers: {
                    ...makeAuthHeader(sessionId)
                },
                params: {
                    projectId
                }
            }
        )

        if (isHttpError(response)) return [response]

        return response
    }
}

const activitiesDb = new ActivitiesDb("planscan/activities")

export default activitiesDb
